import { render } from "./PurchaseDash.vue?vue&type=template&id=502d0d37&scoped=true"
import script from "./PurchaseDash.vue?vue&type=script&lang=js"
export * from "./PurchaseDash.vue?vue&type=script&lang=js"

import "./PurchaseDash.vue?vue&type=style&index=0&id=502d0d37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502d0d37"]])

export default __exports__